export const LABEL_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const BACKGROUND_COLORS = [
  "rgba(255, 99, 132, 0.2)",
  "rgba(54, 162, 235, 0.2)",
  "rgba(255, 206, 86, 0.2)",
  "rgba(221, 160, 221, 0.2)",
  "rgba(75, 192, 192, 0.2)",
  "rgba(255, 159, 64, 0.2)",
  "rgba(153, 102, 255, 0.2)",
  "rgba(160, 82, 45, 0.2)",
  "rgba(220, 20, 60, 0.2)",
  "rgba(189, 183, 107, 0.2)",
  "rgba(188, 143, 143, 0.2)",
  "rgba(64, 224, 208, 0.2)",
  "rgba(148, 0, 211, 0.2)",
  "rgba(72, 61, 139, 0.2)",
  "rgba(175, 238, 238, 0.2)",
  "rgba(0, 255, 127, 0.2)",
  "rgba(128, 0, 0, 0.2)",
  "rgba(139, 69, 19, 0.2)",
  "rgba(95, 158, 160, 0.2)",
  "rgba(255, 20, 147, 0.2)",
];

export const BORDER_COLORS = [
  "rgba(255, 99, 132, 1)",
  "rgba(54, 162, 235, 1)",
  "rgba(255, 206, 86, 1)",
  "rgba(221, 160, 221, 1)",
  "rgba(75, 192, 192, 1)",
  "rgba(255, 159, 64, 1)",
  "rgba(153, 102, 255, 1)",
  "rgba(160, 82, 45, 1)",
  "rgba(220, 20, 60, 1)",
  "rgba(189, 183, 107, 1)",
  "rgba(188, 143, 143, 1)",
  "rgba(64, 224, 208, 1)",
  "rgba(148, 0, 211, 1)",
  "rgba(72, 61, 139, 1)",
  "rgba(175, 238, 238, 1)",
  "rgba(0, 255, 127, 1)",
  "rgba(128, 0, 0, 1)",
  "rgba(139, 69, 19, 1)",
  "rgba(95, 158, 160, 1)",
  "rgba(255, 20, 147, 1)",
];
